import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getBuilders, getSellers } from '../../../selectors/newbuilding';

export function useChatButtonContextValue() {
  const builders = useSelector(getBuilders);
  const sellers = useSelector(getSellers);

  return useMemo(
    () => ({
      builders,
      sellers,
    }),
    [builders, sellers],
  );
}
